import { Injectable } from '@angular/core';
import * as platform from 'platform';

@Injectable({ providedIn: 'root' })
export class PlatformService {
  readonly platform: Platform;

  constructor() {
    switch (platform.os.family) {
      case 'iOS':
        this.platform = 'ios';
        break;
      case 'Android':
        this.platform = 'android';
        break;
      default:
        this.platform = 'desktop';
    }
  }
}

export type Platform = 'desktop' | 'ios' | 'android';
